"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBWeddingPositive = function SvgBWeddingPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M49.072 144.273a48.4 48.4 0 1112.855-95.068 2.097 2.097 0 01-1.111 4.026A44.256 44.256 0 004.893 96.76c.383 18.704 12.498 35.143 30.251 41.045 17.753 5.902 37.3-.01 48.805-14.762 11.506-14.753 12.479-35.15 2.43-50.931a2.098 2.098 0 013.537-2.258 48.4 48.4 0 01-39.845 74.405l-1 .014z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M49.079 133.34c-20.547-.014-37.25-16.572-37.442-37.119-.192-20.546 16.2-37.413 36.743-37.81 1.153 0 2.307 0 3.446.084a2.102 2.102 0 11-.294 4.194 32.01 32.01 0 00-3.068-.077c-15.261.314-28.349 10.975-31.743 25.857-3.394 14.882 3.777 30.164 17.393 37.064 13.615 6.9 30.18 3.646 40.173-7.891 9.994-11.537 10.853-28.396 2.082-40.889a2.1 2.1 0 013.432-2.418A37.475 37.475 0 0149.89 133.34h-.811z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M95.117 143.35a48.932 48.932 0 01-9.213-.88 2.097 2.097 0 11.797-4.118c3.07.589 6.193.854 9.318.79 19.985-.415 37.202-14.198 41.981-33.608 4.779-19.41-4.072-39.612-21.58-49.257-17.51-9.645-39.314-6.332-53.167 8.08-13.854 14.41-16.304 36.329-5.975 53.443a2.097 2.097 0 11-3.586 2.174c-11.33-18.75-8.656-42.774 6.523-58.573 15.178-15.799 39.075-19.434 58.264-8.863 19.19 10.57 28.888 32.711 23.646 53.983-5.243 21.272-24.119 36.372-46.022 36.815l-.986.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M95.837 132.41a2.097 2.097 0 01-.042-4.194c15.273-.307 28.374-10.974 31.771-25.867 3.398-14.893-3.782-30.187-17.411-37.086-13.629-6.9-30.205-3.634-40.197 7.92-9.992 11.555-10.834 28.429-2.04 40.92a2.097 2.097 0 01-3.433 2.411c-9.9-14.066-8.95-33.066 2.303-46.076 11.252-13.01 29.918-16.686 45.263-8.915 15.346 7.77 23.43 24.99 19.604 41.76-3.826 16.77-18.579 28.781-35.776 29.127h-.042zM71 41.348a2.097 2.097 0 01-1.447-.588L50.722 22.67A12.513 12.513 0 0164.45 2.209a2.098 2.098 0 01-1.698 3.838 8.311 8.311 0 00-9.13 13.596l18.832 18.105A2.097 2.097 0 0171 41.362v-.014z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M77.592 34.47a2.097 2.097 0 01-1.51-3.552l11.485-11.953a8.323 8.323 0 10-12.016-11.52L72.26 10.87a2.097 2.097 0 01-3.02-2.908l3.285-3.425a12.513 12.513 0 1118.042 17.336L79.088 33.826a2.097 2.097 0 01-1.496.643z",
    fill: "#1B7"
  })));
};

var _default = SvgBWeddingPositive;
exports["default"] = _default;